
<template >
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">

      <van-nav-bar title="整改审批" left-text="返回" left-arrow @click-left="$router.back()" id="topbar"/>

        <van-form @submit="onSubmit">
          <div style="padding:20px;">

                <div class="infoTit">整改审批</div>
                <div class="topDiv">
                  <van-cell-group>
                    <van-field name="uploader" label="整改照片" input-align="right">
                      <template #input>
                        <van-image v-if="problem.rectificationPhotos.length" v-for="(p, i) of (problem.rectificationPhotos ? problem.rectificationPhotos : '').split(',')" :key="i"
                                   :src="apiUrl + 'download/' + p" width="60" height="60" @click="showSignPhoto(p)" style="margin-right: 10px"/>
                        <van-col v-else>无</van-col>
                      </template>
                    </van-field>
                  </van-cell-group>
                  <van-cell-group>
                    <van-field name="uploader" label="整改附件" input-align="right">
                      <template #input>
                        <div v-if="problem.rectificationAtt" class="file-list">
                          <span v-for="(fileId, i) of (problem.rectificationAtt?problem.rectificationAtt:'').split(',').filter(Boolean)"
                                :key="i" class="file-name-item" @click="previewFile(fileId)">
                               {{ fileIdToName[fileId] || `文件加载中...` }}
                          </span>
                        </div>
                        <van-col v-else>无</van-col>
                      </template>
                    </van-field>
                  </van-cell-group>
                    <van-cell-group>
                        <van-field v-if="problem.rectificationRemark" label="整改备注" type="textarea" v-model="problem.rectificationRemark" rows="1" readonly autosize input-align="right"/>
                        <van-field v-else label="整改备注" type="textarea" value="无" rows="1" readonly autosize input-align="right"/>
                    </van-cell-group>
                  <van-cell-group>
                    <van-field required name="rectificationStatus" label="审批类型" input-align="right" :rules="[{ required: true, message: '请选择审批类型'}]">
                      <template #input>
                        <van-radio-group v-model="problem.rectificationStatus" direction="horizontal">
                          <van-radio v-for="(item,index) in approvalType" :key="index" :name="item.value">{{item.label}}</van-radio>
                        </van-radio-group>
                      </template>
                    </van-field>
                  </van-cell-group>
                  <van-cell-group>
                    <van-field label="审批意见" type="textarea" maxlength="200" show-word-limit
                               v-model="problem.approvalOpinions" input-align="right" placeholder="点击输入审批意见"/>
                  </van-cell-group>
                </div>

          </div>
          <div style="position: fixed;bottom: 0;width: 100%;">
              <van-button block color="#1B75F6" native-type="submit">完成提交</van-button>
          </div>
      </van-form>
  </div>
</template>

<script>
    import $ from '@/fly'
    import uploadfilecommon from '@/libs/uploadfilecommon';
    import {Toast, Dialog, ImagePreview} from 'vant';
    import Setting from "@/setting";
    import {createPreView} from "@/utils/PreView";
    export default {
        name: 'project-completeProblem',
        data () {
            return {
                clientHeight: window.screen.height,
                problem: {
                    rectificationPhotos: '',
                    rectificationAtt:'',
                    rectificationRemark: '',
                    rectificationStatus:'',
                    approvalOpinions:''
                },
                fileIdToName: {},
                // rectificationPhoto: [],
                // rectificationAtt: [],
                // rectificationPhotoIds: [],
                approvalType: [
                  { value: '1', label: '通过' },
                  { value: '2', label: '退回' },
                ],
                apiUrl: Setting.apiBaseURL,
                index:-1
            }
        },
        watch: {
          'problem.rectificationAtt': {
            immediate: true,
            handler(newVal) {
              if (newVal) {
                this.loadAllFileNames(newVal); // 批量加载文件名
              } else {
                this.fileIdToName = {};
              }
            }
          }
        },
        methods: {
          async loadAllFileNames(attStr) {
            const fileIds = attStr.split(',').filter(Boolean);
            if (!fileIds.length) return;

            for (const fileId of fileIds) {
              if (this.fileIdToName[fileId]) continue;
              try {
                // 调用原有的 getFileName 逻辑，获取文件名
                const fileName = await this.getFileName(fileId);
                // 存入缓存（响应式更新，模板会自动刷新）
                this.$set(this.fileIdToName, fileId, fileName);
              } catch (err) {
                // 接口失败时，设置兜底名称
                this.$set(this.fileIdToName, fileId, `文件${fileId.slice(-6)}`);
                console.error(`获取文件${fileId}名称失败：`, err);
              }
            }
          },
            showSignPhoto(id) {
              ImagePreview({
                images: [
                  Setting.apiBaseURL + 'download/' + id
                ],
                closeable: true
              });
            },
            previewFile (fileId) {
              window.open(createPreView(Setting.apiBaseURL + 'download/' + fileId, this.getFileName(fileId)));
            },
            async getFileName (fileId) {
              return await $.get(`filename/${fileId}`)
            },
            // beforeDel (file, detail) {
            //     Dialog.confirm({
            //         title: '是否删除整改照片'
            //     }).then(() => {
            //         const aId = this.rectificationPhotoIds[detail.index]
            //         $.delete('deleteFile/' + aId).then(_ => {
            //             Toast.success('删除成功！');
            //             this.rectificationPhotoIds.splice(detail.index, 1);
            //             this.rectificationPhoto.splice(detail.index, 1);
            //             return true;
            //         }).catch(err => {
            //             Toast.fail(err.message);
            //             return false;
            //         });
            //     })
            // },
            // beforeRead (file) {
            //     if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
            //         Toast('只允许上传jpg/png格式的图片！')
            //         return false;
            //     }
            //     return true
            // },
            // async afterRead (file) {
            //     // 此时可以自行将文件上传至服务器
            //     file.status = 'uploading';
            //     file.message = '上传中...';
            //     const fid = await uploadfilecommon(file.file, '')
            //     file.status = 'done';
            //     file.message = '上传成功';
            //     if (fid && fid.length === 32) {
            //         this.rectificationPhotoIds.push(fid)
            //     }
            // },
            onSubmit () {
                // var ids = ''
                // this.rectificationPhotoIds.forEach(id => {
                //     ids += id;
                //     ids += ',';
                // })
                // this.problem.rectificationPhotos = ids.substring(0, ids.length - 1);
                // this.problem.rectificationStatus = '1';
                $.put('problem/approval', this.problem).then(() => {
                    Toast.success('整改审批完成！');
                  if(this.index!==-1){
                    let problemCheckTaskList = JSON.parse(localStorage.getItem('checkTaskProblemList'))
                    problemCheckTaskList[this.index].rectificationStatus = '1'
                    localStorage.setItem('checkTaskProblemList',JSON.stringify(problemCheckTaskList))
                  }
                    this.$router.back();
                }).catch(err => {
                    Toast.fail(err.message);
                })
            }
        },
        mounted () {
          const routeProblem = this.$route.params.problem || {};
            this.problem = {
              ...this.problem,
              ...routeProblem
            };

            const index = this.$route.params.num
            this.index = index!=undefined ? index : -1
            if (this.problem.approvalOpinions === null) {
              this.problem.approvalOpinions = '';
            }
            if (this.problem.rectificationPhotos === null) {
              this.problem.rectificationPhotos = '';
            }
            if (this.problem.rectificationStatus !== '1' || this.problem.rectificationStatus !== '2') {
              this.problem.rectificationStatus = '';
            }
        }
    }
</script>

<style lang="less" scoped>
    .file-name-item {
      margin: 0 10px;
      background-color: #f5f7fa;
      color: #0066ff;
      cursor: pointer;
    }

    .file-name-item:hover {
      background-color: #e8f0fe;
    }
    .topDiv{
        margin-top:30px;
        padding:20px;
        background-color: #FFFFFF;
    }
    .infoTit{
      color:#242E42;
      font-size: 30px;
      font-weight: bold;
    }

</style>
